<template>
  <v-form 
    ref = "form" 
    v-model = "valid">
    <slot />
  </v-form>
</template>

<script>
export default {
  name: 'FormValidation',
  props: {
    append: {
      type: Number,
      default: 0
    },
    value: {
      type: [ Object, Number ],
      default() {
        return { errorsCount: 0 }
      }
    }
  },
  data() {
    return {
      valid: false,
      internalErrorsCount: 0,
      errorsCount: 0,
      errorsBagRef: {}
    }
  },
  watch: {
    value(val) {
      if (val && val.errorsCount) {
        this.$emit('input', val)
      }
    },
    append() {
      this.handleParamsChanges()
    },
    valid: {
      immediate: true,
      handler() {
        this.handleParamsChanges()
      }
    },
    errorsBagRef: {
      immediate: true,
      deep: true,
      handler() {
        this.handleParamsChanges()
      }
    }
  },
  methods: {
    updateErrorsBagRef() {
      this.errorsBagRef =
        this.$refs.form && this.$refs.form.errorBag
          ? this.$refs.form.errorBag
          : {}
    },
    handleParamsChanges(val) {
      this.updateErrorsBagRef()
      this.internalErrorsCount = Object.keys(this.$_.pickBy(this.errorsBagRef, v => v))
        .length
      this.errorsCount = this.internalErrorsCount + this.append
      this.$emit('input', { errorsCount: this.errorsCount })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
